import { useNavigate, useParams } from "react-router-dom";
import "../../styles/pages.css";
import Banner from "../ui/Banner";
import ceo from "../../assets/images/ceo.png";
import about from "../../assets/images/about.png";
import historyimg from "../../assets/images/historyimg.png";

const About = () => {
  const navigate = useNavigate();
  const { tab } = useParams();
  const activeTab = tab || "greeting";

  const handleTabChange = (tabId) => {
    navigate(`/about/${tabId}`);
  };

  const bannerConfig = {
    backgroundImage: about,
    title: "회사소개",
    description: ["에코텍글로벌은 국내 시설농가의 현실에 맞춘 맞춤형 엔지니어 양성과", "혁신적 온실 관리 솔루션으로 농가 소득 증대를 지원합니다."],
    tabs: [
      { id: "greeting", name: "인사말" },
      { id: "history", name: "히스토리" },
    ],
  };

  return (
    <div className="about-container">
      <Banner {...bannerConfig} activeTab={activeTab} onTabChange={handleTabChange} />
      {activeTab === "greeting" && <GreetingContent />}
      {activeTab === "history" && <HistoryContent />}
    </div>
  );
};

const GreetingContent = () => (
  <div className="greeting-section">
    <div className="greeting-header">
      <h2>
        시설 온실의 미래는
        <br />
        에코텍글로벌이 열어가겠습니다.
      </h2>
    </div>

    <div className="greeting-content">
      <div className="greeting-text">
        <div className="gretting-text-bg">
          <div className="text-container">
            <p>에코텍글로벌의 성장에 함께 해주신 모든 분들께 감사드리며</p>
            <p>더욱 다담하고 차별화 된 서비스로 보답하겠습니다.</p>
            <div className="ceo-image">
              <img src={ceo} alt="에코텍글로벌 대표 강병욱" />
            </div>
          </div>
        </div>
        <div className="company-description">
          <p>
            온실 업계 20년 경력과 기술, 노하우를 보유하고 있으며 기술집약적 선도기업으로, 온실 시공에서 부터 작물 재배 전주기 관리까지 종합적 서비스를 제공하고 있고 <br />
            또한 선진기술 도입과 국산화로 농가에 많은 혜택을 제공하고 있습니다. 이러한 기술력과 보유 Eng'r의 전문화로 온실의 재배환경을 개선하고 사회적으로는 ESG 실천에 <br /> 기여하고 있을 뿐 아니라
            경제적 파급효과, 일자리 창출 등에 기여하고 한국의 선진 온실 기술의 해외 보급을 위해 정진하고 있습니다.
          </p>

          <p>
            국내 시설 온실의 규모와 현실에 맞는 작업방법과 엔지니어의 양성을 위해 꾸준히 노력해 왔으며 <br />
            끊임없는 기술 개발과 창의적인 생각으로 품질 좋은 제품들을 개발하여 시설농가에 보탬이 되고자 노력해 왔습니다.
          </p>

          <p>앞으로도 시설 농가의 소득증대와 온실관리의 편의를 도모하기 위해 뛰고 또 뛰는 에코텍글로벌이 되겠습니다.</p>
        </div>

        <div className="ceo-signature">
          <p>
            에코텍글로벌 대표 <strong>강병욱</strong>
          </p>
        </div>
      </div>
    </div>
  </div>
);

const HistoryContent = () => (
  <>
    <div className="history-section">
      <h2>기업정보</h2>
      <div className="company-info-container">
        <div className="company-info-left">
          <div className="info-row">
            <div className="info-label">회사명</div>
            <div className="info-content">
              <div className="info-title">Company Name</div>
              <div className="info-value">주식회사 에코텍글로벌</div>
            </div>
          </div>

          <div className="info-row">
            <div className="info-label">대표</div>
            <div className="info-content">
              <div className="info-title">CEO</div>
              <div className="info-value">강병욱</div>
            </div>
          </div>

          <div className="info-row">
            <div className="info-label">설립일</div>
            <div className="info-content">
              <div className="info-title">Founding date</div>
              <div className="info-value">2012년 3월 26일</div>
            </div>
          </div>
        </div>

        <div className="company-info-right">
          <img src={historyimg} alt="회사 건물 이미지" className="company-building" />
        </div>
      </div>
      <div className="company-history">
        <div className="text-container">
          <p>ECOTECH GLOBAL HISTORY</p>
          <p>
            2008년 전주대학교 벤처창업관 1인 창조기업으로 시작한 에코텍글로벌, 현재 <span>시설 온실 자재 전문기업</span>이 되었습니다.
          </p>
        </div>
      </div>
    </div>
    <div className="history-timeline">
      <div className="timeline-period">
        <div className="period-year">2022 ~ 2025</div>
        <div className="period-events">
          <div className="event-item">우즈베키스탄 치르치크시에 테크노파크 공장설립</div>
          <div className="event-item">표창장 수상#1. 중소기업중앙회 / 표창장 수상#2. 조달청장</div>
          <div className="event-item">기업부설연구소 설립</div>
          <div className="event-item">전북대학교에서 기술이전 3건</div>
          <div className="event-item">몽골 은혜농장과 MOU체결</div>
          <div className="event-item">Main-Biz 인증+INNO Biz인증</div>
          <div className="event-item">상공회의소 회원사</div>
          <div className="event-item">몽골 식물 및 생명공학연구기관 IPAS와 '노지스마트팜 플랫폼 시범사업'을 위한 MOU 체결</div>
          <div className="event-item">ISO9001, 14001 인증 취득</div>
        </div>
      </div>
      <div className="timeline-period">
        <div className="period-year">2018 ~ 2021</div>
        <div className="period-events">
          <div className="event-item">노루표 페인트 농업용 차광제 공동개발 참여</div>
          <div className="event-item">국내 최초 농업용 작물파쇄기 개발</div>
          <div className="event-item">국내 최초 노후유리온실 리모델링 기술 상용화</div>
          <div className="event-item">국내 차광제 지사 설립</div>
        </div>
      </div>
      <div className="timeline-period">
        <div className="period-year">2016 ~ 2017</div>
        <div className="period-events">
          <div className="event-item">특허#1. 비닐하우스 차광제 및 그 제조방법</div>
          <div className="event-item">특허#2. 물홈통 특허</div>
          <div className="event-item">특허#3. 복수천장 개별 제어가 가능한 온실천장의 개폐시스템</div>
          <div className="event-item">네덜란드 로얄브링크만(Royal Brinkman) 한국지사</div>
        </div>
      </div>
      <div className="timeline-period">
        <div className="period-year">2013 ~ 2015</div>
        <div className="period-events">
          <div className="event-item">(주)에코팜 설립</div>
          <div className="event-item">차광제 및 온실 시공 전문법인</div>
          <div className="event-item">기술보증기업 벤처기업등록</div>
        </div>
      </div>
      <div className="timeline-period">
        <div className="period-year">2008</div>
        <div className="period-events">
          <div className="event-item">전주대학교 벤처기업 1호</div>
          <div className="event-item">비닐온실용 광차단제 개발 및 시공설치 전문기업</div>
        </div>
      </div>
    </div>
  </>
);

export default About;
